// One visual family for the three tab rows on the Analytics dashboard (scope
// bar on the page canvas, Trend metric tabs and Audience tabs inside panels).
// Containers differ by surface so they sit on their background; the pills,
// typography and states are identical.
//
// Sizing: 30px pill inside a 2px-padded container = 34px control. Each pill
// extends its hit area over the container padding (::before) so the touch
// target is the full 34px even though the visible pill is 30px.

// Canvas: reads as its own control next to the KPI cards. Full width below sm
// (the caller lets its pills flex), auto width from sm up.
export const TAB_GROUP_CANVAS_CLASS = 'flex w-full items-center gap-0.5 rounded-lg bg-surface-2 p-0.5 ring-1 ring-inset ring-white/[0.06] shadow-[0_2px_6px_rgba(0,0,0,0.28)] sm:inline-flex sm:w-auto';
// Inside a panel (bg-surface-2): a darker well.
export const TAB_GROUP_PANEL_CLASS = 'inline-flex items-center gap-0.5 rounded-lg bg-surface-1 p-0.5';

const ITEM_BASE = 'relative flex h-[30px] shrink-0 items-center justify-center whitespace-nowrap rounded-md px-3 text-tiny font-medium leading-none transition-colors hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-main/60 before:absolute before:inset-x-0 before:-inset-y-0.5 before:content-[\'\']';
const ITEM_ACTIVE = 'bg-surface-4 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.06),0_1px_2px_rgba(0,0,0,0.3)]';
const ITEM_IDLE = 'text-surface-8 hover:bg-white/[0.04] hover:text-white';

/**
 * Pill classes for one tab.
 * @param {boolean} active
 * @param {{ disabled?: boolean, fill?: boolean }} opts
 *   fill: the pill fills its wrapper (scope bar pills sit in <li> cells that flex below sm).
 */
export function tabItemClass(active, { disabled = false, fill = false } = {}) {
	return [
		ITEM_BASE,
		fill ? 'w-full' : '',
		active ? ITEM_ACTIVE : ITEM_IDLE,
		disabled ? 'cursor-not-allowed opacity-40 hover:bg-transparent hover:text-surface-8' : '',
	].filter(Boolean).join(' ');
}
